import React, { useState, useEffect } from "react";
import "katex/dist/katex.min.css";
import katex from "katex";
import { Remarkable } from "remarkable";
import { useMutation } from "react-query";
import { useLocation } from "react-router-dom";
import { getSessionById } from "../../services/teacherSession.service";
/* Icons */
import icon_alignLeft from "../../assets/icons/format_align_left.svg";
import icon_alignRight from "../../assets/icons/format_align_right.svg";
import icon_alignCenter from "../../assets/icons/format_align_center.svg";
import icon_alignJustify from "../../assets/icons/format_align_justify.svg";

// const examplePlan = `
// ¡Excelente elección! La idea de proyecto "Estadísticas del fútbol" suena muy interesante. A continuación, te presentaré la versión definitiva de la idea del proyecto, utilizando la plantillaProyecto:

// <stage_1>

// # Título: Estadísticas del fútbol
// Clase: Matemáticas
// Grado: 4
// Edades: 12 y 14
// Número de Estudiantes: 36
// Duración: 5 clases de 20 minutos cada una

// ## Pregunta Guía:
// ¿Cómo podemos utilizar las estadísticas para analizar los resultados de los partidos de fútbol?

// ## Objetivos de Aprendizaje:
// - Utilizar habilidades matemáticas para analizar y presentar estadísticas de los resultados de partidos de fútbol.
// - Aplicar conceptos de análisis numérico, gráficos y tablas para identificar tendencias y realizar comparaciones.
// - Utilizar conceptos matemáticos como promedios, porcentajes y estimaciones en el contexto del fútbol.

// ## Resumen del Proyecto:
// En este proyecto, los estudiantes investigarán datos de partidos de fútbol para analizar y presentar estadísticas sobre los resultados de los equipos. A través del análisis numérico, gráficos y tablas, los estudiantes realizarán comparaciones, identificarán tendencias y propondrán conclusiones. Además, podrán aplicar conceptos matemáticos como promedios, porcentajes y estimaciones. Este proyecto permitirá a los estudiantes desarrollar habilidades matemáticas y al mismo tiempo explorar su interés por el fútbol.

// </stage_1>

// Con esta versión definitiva, podemos continuar con la planificación y desarrollo del proyecto de ABP. ¿Hay algo más que te gustaría agregar o discutir sobre esta idea de proyecto?

//  ¡Perfecto! Tomaremos la propuesta de "Infografías comparativas" como producto individual para el proyecto "Estadísticas del fútbol". A continuación, te presento la versión definitiva de los productos individuales:

// <stage_2>

// **Producto individual: Infografías comparativas**
// Los estudiantes crearán infografías en las que compararán los resultados de diferentes equipos y jugadores utilizando gráficos y estadísticas. Deberán seleccionar los datos relevantes, realizar cálculos y presentar la información de manera clara y visualmente atractiva. Las infografías deben incluir elementos como tablas, gráficos de barras, líneas y sectores para mostrar las estadísticas y hacer comparaciones entre equipos y jugadores. También se deben incluir títulos, leyendas y notas explicativas para brindar una comprensión completa de los datos presentados.

// **Evaluación de producto individual**
// Se evaluará la capacidad de los estudiantes para seleccionar los datos relevantes y calcular estadísticas de manera precisa. También se evaluará la presentación y organización de la información en la infografía, la claridad y efectividad de los gráficos utilizados, así como la coherencia y precisión de las comparaciones realizadas. Además, se evaluará la creatividad y originalidad en el diseño de la infografía, y la capacidad de los estudiantes para comunicar la información de manera clara y visualmente atractiva.

// </stage_2>

// Ahora pasemos a la creación de los productos grupales. ¿Hay algo más que te gustaría agregar o discutir sobre los productos individuales antes de continuar?

//  ¡Perfecto! Me alegra saber que estás de acuerdo con los hitos propuestos y su duración. Ahora pasemos a la versión definitiva de todos los hitos del proyecto de Aprendizaje Basado en Proyectos "Estadísticas del fútbol":

// <stage_3>

// **Hito de Lanzamiento: Introducción al proyecto "Estadísticas del fútbol"**
// - Duración: 1 clase de 20 minutos
// - Objetivos:
//   - Comprender el propósito y los objetivos del proyecto.
//   - Familiarizarse con la pregunta guía y las habilidades matemáticas relacionadas.
// - Materiales: Proyector o pizarra, presentación con la pregunta guía y los objetivos del proyecto.
// - Experiencias de aprendizaje:
//   1. Presentar la idea del proyecto "Estadísticas del fútbol" y en qué consistirá.
//   2. Explicar la importancia de las estadísticas en el fútbol y cómo pueden ayudarnos a analizar los resultados de los partidos.
//   3. Presentar la pregunta guía del proyecto.
//   4. Discutir los objetivos de aprendizaje del proyecto.
//   5. Responder preguntas y aclarar dudas de los estudiantes.

// **Hito de Cierre: Presentación de infografías comparativas**
// - Duración: 3 clases de 20 minutos cada una
// - Objetivos:
//   - Presentar las infografías comparativas creadas por los estudiantes.
//   - Analizar y comparar los resultados presentados en las infografías.
// - Materiales: Infografías creadas por los estudiantes, espacio para proyección y discusión.
// - Experiencias de aprendizaje:
//   1. Los estudiantes exhiben y presentan sus infografías comparativas.
//   2. Los estudiantes explican los datos, gráficos y conclusiones presentadas en las infografías.
//   3. Se fomenta la participación y se realiza una discusión grupal para analizar y comparar los resultados presentados en las infografías.
//   4. Se promueve la retroalimentación constructiva entre los estudiantes.
//   5. Se reflexiona sobre los objetivos de aprendizaje del proyecto y se discute la importancia de utilizar estadísticas para analizar resultados.

// ¡Felicitaciones! Ya hemos finalizado la estructuración de los hitos para el proyecto "Estadísticas del fútbol". Recuerda que los hitos son puntos clave en el desarrollo del proyecto y te ayudarán a mantener un plan de trabajo organizado y progresivo. Si tienes alguna otra consulta o necesitas realizar algún ajuste posteriormente, no dudes en decírmelo. Estoy aquí para ayudarte en todo momento.

// </stage_3>
// bundle.js:1878 textToProcess  ¡Excelente elección! La idea de proyecto "Estadísticas del fútbol" suena muy interesante. A continuación, te presentaré la versión definitiva de la idea del proyecto, utilizando la plantillaProyecto:

// <stage_1>

// # Título: Estadísticas del fútbol
// Clase: Matemáticas
// Grado: 4
// Edades: 12 y 14
// Número de Estudiantes: 36
// Duración: 5 clases de 20 minutos cada una

// ## Pregunta Guía:
// ¿Cómo podemos utilizar las estadísticas para analizar los resultados de los partidos de fútbol?

// ## Objetivos de Aprendizaje:
// - Utilizar habilidades matemáticas para analizar y presentar estadísticas de los resultados de partidos de fútbol.
// - Aplicar conceptos de análisis numérico, gráficos y tablas para identificar tendencias y realizar comparaciones.
// - Utilizar conceptos matemáticos como promedios, porcentajes y estimaciones en el contexto del fútbol.

// ## Resumen del Proyecto:
// En este proyecto, los estudiantes investigarán datos de partidos de fútbol para analizar y presentar estadísticas sobre los resultados de los equipos. A través del análisis numérico, gráficos y tablas, los estudiantes realizarán comparaciones, identificarán tendencias y propondrán conclusiones. Además, podrán aplicar conceptos matemáticos como promedios, porcentajes y estimaciones. Este proyecto permitirá a los estudiantes desarrollar habilidades matemáticas y al mismo tiempo explorar su interés por el fútbol.

// </stage_1>

// Con esta versión definitiva, podemos continuar con la planificación y desarrollo del proyecto de ABP. ¿Hay algo más que te gustaría agregar o discutir sobre esta idea de proyecto?

//  ¡Perfecto! Tomaremos la propuesta de "Infografías comparativas" como producto individual para el proyecto "Estadísticas del fútbol". A continuación, te presento la versión definitiva de los productos individuales:

// <stage_2>

// **Producto individual: Infografías comparativas**
// Los estudiantes crearán infografías en las que compararán los resultados de diferentes equipos y jugadores utilizando gráficos y estadísticas. Deberán seleccionar los datos relevantes, realizar cálculos y presentar la información de manera clara y visualmente atractiva. Las infografías deben incluir elementos como tablas, gráficos de barras, líneas y sectores para mostrar las estadísticas y hacer comparaciones entre equipos y jugadores. También se deben incluir títulos, leyendas y notas explicativas para brindar una comprensión completa de los datos presentados.

// **Evaluación de producto individual**
// Se evaluará la capacidad de los estudiantes para seleccionar los datos relevantes y calcular estadísticas de manera precisa. También se evaluará la presentación y organización de la información en la infografía, la claridad y efectividad de los gráficos utilizados, así como la coherencia y precisión de las comparaciones realizadas. Además, se evaluará la creatividad y originalidad en el diseño de la infografía, y la capacidad de los estudiantes para comunicar la información de manera clara y visualmente atractiva.

// </stage_2>

// Ahora pasemos a la creación de los productos grupales. ¿Hay algo más que te gustaría agregar o discutir sobre los productos individuales antes de continuar?

//  ¡Perfecto! Me alegra saber que estás de acuerdo con los hitos propuestos y su duración. Ahora pasemos a la versión definitiva de todos los hitos del proyecto de Aprendizaje Basado en Proyectos "Estadísticas del fútbol":

// <stage_3>

// **Hito de Lanzamiento: Introducción al proyecto "Estadísticas del fútbol"**
// - Duración: 1 clase de 20 minutos
// - Objetivos:
//   - Comprender el propósito y los objetivos del proyecto.
//   - Familiarizarse con la pregunta guía y las habilidades matemáticas relacionadas.
// - Materiales: Proyector o pizarra, presentación con la pregunta guía y los objetivos del proyecto.
// - Experiencias de aprendizaje:
//   1. Presentar la idea del proyecto "Estadísticas del fútbol" y en qué consistirá.
//   2. Explicar la importancia de las estadísticas en el fútbol y cómo pueden ayudarnos a analizar los resultados de los partidos.
//   3. Presentar la pregunta guía del proyecto.
//   4. Discutir los objetivos de aprendizaje del proyecto.
//   5. Responder preguntas y aclarar dudas de los estudiantes.

// **Hito de Cierre: Presentación de infografías comparativas**
// - Duración: 3 clases de 20 minutos cada una
// - Objetivos:
//   - Presentar las infografías comparativas creadas por los estudiantes.
//   - Analizar y comparar los resultados presentados en las infografías.
// - Materiales: Infografías creadas por los estudiantes, espacio para proyección y discusión.
// - Experiencias de aprendizaje:
//   1. Los estudiantes exhiben y presentan sus infografías comparativas.
//   2. Los estudiantes explican los datos, gráficos y conclusiones presentadas en las infografías.
//   3. Se fomenta la participación y se realiza una discusión grupal para analizar y comparar los resultados presentados en las infografías.
//   4. Se promueve la retroalimentación constructiva entre los estudiantes.
//   5. Se reflexiona sobre los objetivos de aprendizaje del proyecto y se discute la importancia de utilizar estadísticas para analizar resultados.

// ¡Felicitaciones! Ya hemos finalizado la estructuración de los hitos para el proyecto "Estadísticas del fútbol". Recuerda que los hitos son puntos clave en el desarrollo del proyecto y te ayudarán a mantener un plan de trabajo organizado y progresivo. Si tienes alguna otra consulta o necesitas realizar algún ajuste posteriormente, no dudes en decírmelo. Estoy aquí para ayudarte en todo momento.

// </stage_3>
// `;

const MentuABPEditor = () => {
  const [htmlContent, setHtmlContent] = useState("");
  const [, setEditableContent] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");

  useEffect(() => {
    sessionByIdMutation.mutate(sessionId);
    // eslint-disable-next-line
  }, []);

  const sessionByIdMutation = useMutation(getSessionById, {
    onSuccess: (data) => {
      if (data?.data) {
        const historyStep1 = data?.history.find((e) => e.superPower.slug === 'abp1');
        console.log('data?.history ', data?.history);
        const historyStep1Messages = JSON.parse(historyStep1.memory_array);
        const historyStep2 = data?.history.find((e) => e.superPower.slug === 'abp2');
        const historyStep2Messages = JSON.parse(historyStep2.memory_array);
        const historyStep3Messages = JSON.parse(data?.data?.memory_array);
        const findStage1 = historyStep1Messages.find(
          (e) =>
            (e?.role === "assistant" || e?.type === "ai") &&
            (e?.content?.includes("<stage_1>") ||
              e?.data?.content?.includes("<stage_1>"))
        );
        const findStage2 = historyStep2Messages.find(
          (e) =>
            (e?.role === "assistant" || e?.type === "ai") &&
            (e?.content?.includes("<stage_2>") ||
              e?.data?.content?.includes("<stage_2>"))
        );
        console.log('historyStep3Messages ', historyStep3Messages);
        const findStage3 = historyStep3Messages.find(
          (e) =>
            (e?.role === "assistant" || e?.type === "ai") &&
            (e?.content?.includes("<stage_3>") ||
              e?.data?.content?.includes("<stage_3>"))
        );

        const currentContent = `${
          findStage1?.content || findStage1?.data?.content
        }  \n\n ${findStage2.content || findStage2?.data?.content} \n\n ${
          findStage3.content || findStage3?.data?.content
        } `;
        processContent(currentContent);
      }
    },
    onError: (error) => {},
  });

  const processContent = (content) => {
    const stageContents = extractStageContent(content);
    let combinedContent = "";
    // Concatenar el contenido de cada etapa, si está disponible
    if (stageContents["stage_1"]) {
      combinedContent += stageContents["stage_1"] + "\n\n";
    }
    if (stageContents["stage_2"]) {
      combinedContent += stageContents["stage_2"] + "\n\n";
    }
    if (stageContents["stage_3"]) {
      combinedContent += stageContents["stage_3"] + "\n\n";
    }

    // Procesar el contenido combinado
    if (combinedContent) {
      processText(combinedContent);
    }
  };

  const extractStageContent = (text) => {
    const stageRegex = /<(stage_[123])>(.*?)<\/\1>/gs;
    let matches;
    let stageContents = {};

    while ((matches = stageRegex.exec(text)) !== null) {
      // matches[1] es el identificador de la etapa (stage_1, stage_2, stage_3)
      // matches[2] es el contenido
      stageContents[matches[1]] = matches[2].trim();
    }

    return stageContents;
  };

  const convertListMarkdown = (markdownText) => {
    let processedText = markdownText;

    // Convierte los títulos que terminan en ':' en negrita
    processedText = processedText.replace(
      /^(?!#+\s)(.*?:)$/gm,
      (match, title) => `<strong>${title}</strong>\n`
    );

    // Convierte texto en negrita
    processedText = processedText.replace(
      /\*\*(.*?)\*\*/g,
      (match, text) => `<strong>${text}</strong>`
    );

    // Busca y procesa bloques de listas con guiones

    processedText = processedText.replace(
      /^[\s]*\-\s+(.+)/gm, // eslint-disable-line
      (match, text) => `<li class="editor-li">${text.trim()}</li>`
    );

    // Agrega las etiquetas <ul> alrededor de los elementos <li> no ordenados
    processedText = processedText.replace(
      /(<li class="editor-li">.*?<\/li>)/gs,
      (match) => `<ul>\n${match}\n</ul>`
    );

    // Procesa listas numeradas
    processedText = processedText.replace(
      /^[\s]*(\d+)\.\s+(.+)/gm,
      (match, number, text) =>
        `<li style="list-style: none">${number}. ${text.trim()}</li>`
    );

    // Agrega las etiquetas <ol> alrededor de los elementos <li> numerados
    processedText = processedText.replace(
      /(<li class="editor-li-numbers">.*?<\/li>)/gs,
      (match) => `<ol>\n${match}\n</ol>`
    );

    // Convierte las opciones de las preguntas de opción múltiple con salto de línea después de cada opción
    processedText = processedText.replace(
      /(\w\)) ([^\n]+)/g,
      (match, bullet, text) =>
        `<div class="editor-list-options-letters">  ${bullet} ${text}</div>\n`
    );

    // Elimina líneas vacías entre las etiquetas <ul> y <ol>
    processedText = processedText
      .replace(/<\/ul>\s+<ul>/g, "</ul><ul>")
      .replace(/<\/ol>\s+<ol>/g, "</ol><ol>");

    return processedText;
  };

  const processText = (textToProcess) => {
    const md = new Remarkable({
      html: true, // Permite HTML en el input
      breaks: true, // Convierte '\n' en <br>
      typographer: true, // Habilita algunas sustituciones tipográficas
    });

    // KaTeX pre-processing here if needed
    const parsedText = convertListMarkdown(textToProcess);
    let html = md.render(parsedText);

    // KaTeX post-processing
    html = html.replace(/\$(.+?)\$/g, (match, formula) => {
      try {
        return katex.renderToString(formula, {
          throwOnError: false,
          displayMode: false,
        });
      } catch (error) {
        console.error("Error rendering formula with KaTeX:", error);
        return match;
      }
    });

    setHtmlContent(html);
  };

  const applyStyle = (command) => {
    document.execCommand(command, false, null);
  };

  const applyUnderline = () => {
    document.execCommand("underline", false, "");
  };

  const applyStrikethrough = () => {
    document.execCommand("strikeThrough", false, "");
  };

  const alignLeft = () => {
    document.execCommand("justifyLeft", false, "");
  };

  const alignRight = () => {
    document.execCommand("justifyRight", false, "");
  };

  const alignCenter = () => {
    document.execCommand("justifyCenter", false, "");
  };

  const alignJustify = () => {
    document.execCommand("justifyFull", false, "");
  };

  const handleContentEditable = (event) => {
    const updatedHtml = event.target.innerHTML;
    setEditableContent(updatedHtml);
  };

  return (
    <div className="flex flex-col lg-max:max-h-includeBack lg:max-h-includeBack sm-max:h-includeToggle">
      <div className="bg-white hover:bg-white w-full flex flex-row gap-4 items-center justify-start py-2 px-4">
        <button
          className=" text-black font-bold rounded w-8 h-8 flex items-center justify-center"
          onClick={() => applyStyle("bold")}
        >
          𝗕
        </button>
        <button
          className=" text-black font-bold rounded w-8 h-8 flex items-center justify-center italic"
          onClick={() => applyStyle("italic")}
        >
          I
        </button>
        <button
          className="text-black font-bold rounded w-8 h-8 flex items-center justify-center underline"
          onClick={applyUnderline}
        >
          U
        </button>
        <button
          className="text-black font-bold rounded w-8 h-8 flex items-center justify-center line-through"
          onClick={applyStrikethrough}
        >
          𝚂
        </button>
        <button
          className="text-black font-bold rounded w-8 h- flex items-center justify-center"
          onClick={alignLeft}
        >
          <img className="max-w-full w-5" src={icon_alignLeft} alt="" />
        </button>
        <button
          className="text-black font-bold rounded w-8 h- flex items-center justify-center"
          onClick={alignCenter}
        >
          <img className="max-w-full w-5" src={icon_alignCenter} alt="" />
        </button>
        <button
          className="text-black font-bold rounded w-8 h-8 flex items-center justify-center"
          onClick={alignRight}
        >
          <img className="max-w-full w-5" src={icon_alignRight} alt="" />
        </button>
        <button
          className="text-black font-bold rounded w-8 h- flex items-center justify-center"
          onClick={alignJustify}
        >
          <img className="max-w-full w-5" src={icon_alignJustify} alt="" />
        </button>
      </div>
      <div className="flex justify-center overflow-auto lg-max:max-h-includeBack lg:max-h-includeBack sm-max:h-includeToggle pl-0 pr-1 pb-20 pt-0">
        <div
          className="mentu-editor preview h-full"
          contentEditable
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          onInput={handleContentEditable}
        />
      </div>
    </div>
  );
};

export default MentuABPEditor;
